export default {
  REQUEST_ORDERS: 'ACCOUNT / REQUEST_ORDERS',
  REQUEST_DATA_TICKET: 'ACCOUNT / REQUEST_DATA_TICKET',
  REQUEST_DATA_TICKETLINES: 'ACCOUNT / REQUEST_DATA_TICKETLINES',
  ERROR_ORDERS: 'ACCOUNT / ERROR_ORDERS',
  ERROR_ORDERS_GET_DATA_TICKET: 'ACCOUNT / ERROR_ORDERS_GET_DATA_TICKET',
  ERROR_ORDERS_GET_DATA_TICKETLINES: 'ACCOUNT / ERROR_ORDERS_GET_DATA_TICKETLINES',
  SUCCESS_ORDERS: 'ACCOUNT / SUCCESS_ORDERS',
  REQUEST_ORDER: 'ACCOUNT / REQUEST_ORDER',
  ERROR_ORDER: 'ACCOUNT / ERROR_ORDER',
  SUCCESS_ORDER: 'ACCOUNT / SUCCESS_ORDER',
  SUCCESS_USER: 'ACCOUNT / SUCCESS_USER',
  SET_IS_FETCHING: 'ACCOUNT / SET_IS_FETCHING',
  SUCCESS_DATA_TICKET: 'ACCOUNT / SUCCESS_DATA_TICKET',
  SUCCESS_DATA_TICKETLINES: 'ACCOUNT / SUCCESS_DATA_TICKETLINES',
} as const;
